module.exports = __webpack_public_path__ + "images/referenzen/animationsfilm/philips_prograde_small.jpg";